import {
  Body,
  Controller,
  Post,
  Req,
  UploadedFile,
  UseInterceptors,
} from "@nestjs/common";
import { ApiBody, ApiConsumes, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel } from "@project-management-system/shared-models";
import { DriverDto } from "./driver.dto";
import { DriverService } from "./driver.service";
import { FileInterceptor } from "@nestjs/platform-express";
import { diskStorage } from "multer";
import { join } from "path";
import { DriverId } from "./driver-id";

@ApiTags("/driver")
@Controller("driver")
export class DriverController {
  constructor(
    private readonly driverService: DriverService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) {}
  @Post("/createDriver")
  @ApiBody({ type: DriverDto })
  async createDriver(
    @Body() req: any,
    isUpdate: boolean = false
  ): Promise<CommonResponseModel> {
    try {
      return await this.driverService.createDriver(req, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/updateDriver")
  // @ApiBody({ type: DriverDto })
  async updateDriver(
    @Body() req: any,
  ): Promise<CommonResponseModel> {
    try {
      return await this.driverService.createDriver(req, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getActiveDriver")
  @ApiBody({ type: DriverDto })
  async getActiveDriver(@Body() req: any): Promise<CommonResponseModel> {
    try {
      return await this.driverService.getActiveDriver();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getAllDriver")
  @ApiBody({ type: DriverDto })
  async getAllDriver(@Body() req: any): Promise<CommonResponseModel> {
    try {
      return await this.driverService.getAllDriver();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/activateOrDeactivateDriver")
  @ApiBody({ type: DriverDto })
  async activateOrDeactivateDriver(
    @Body() req: any
  ): Promise<CommonResponseModel> {
    return await this.driverService.activateOrDeactivateDriver(req);
  }

  @Post("/fileUpload")
  @ApiBody({ type: DriverDto })
  @ApiConsumes("multipart/form-data")
  @UseInterceptors(
    FileInterceptor("file", {
      limits: { files: 1 },
      storage: diskStorage({
        destination: join(__dirname, "../../../../", `upload_files`),

        // destination: './upload_files',
        filename: (req, file, callback) => {
          console.log(file.originalname);
          const name = file.originalname;
          callback(null, `${name}`);
        },
      }),
      fileFilter: (req, file, callback) => {
        if (
          !file.originalname.match(
            /\.(png|jpeg|PNG|jpg|JPG|pjpeg|gif|tiff|x-tiff|x-png)$/
          )
        ) {
          return callback(
            new Error(
              "Only png,jpeg,PNG,jpg,gif,tiff,x-tiff,z-png files are allowed!"
            ),
            false
          );
        }
        callback(null, true);
      },
    })
  )
  async updateDriverPath(
    @UploadedFile() file,
    @Body() uploadData: any
  ): Promise<CommonResponseModel> {
    console.log(file, "-------file");
    try {
      return await this.driverService.updateDriverPath(
        file.path,
        file.filename,
        uploadData.id
      );
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getDriverDetailsById")
  @ApiBody({ type: DriverId })
  async getDriverDetailsById(
    @Body() req: any
  ): Promise<CommonResponseModel> {
    return await this.driverService.getDriverDetailsById(req);
  }


  @Post("/getDriversByType")
  async getDriversByType(@Body() req: any): Promise<CommonResponseModel> {
    try{
      return await this.driverService.getDriversByType(req);
    }catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }


}
